
import Component from 'vue-class-component';
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { ProfileFI } from '@/profile/types/profile-fi';

const profileNamespace = namespace('profile');

@Component
export default class ProfileAccountDropdown extends Vue {
	@profileNamespace.State('institutions')
	institutions!: ProfileFI[];

	@profileNamespace.State('selectedInstitution')
	public selectedInstitution!: ProfileFI;

	@profileNamespace.Mutation('setSelectedInstitution')
	public setSelectedInstitution!: (institution: ProfileFI) => void;

	get logoUrl(): string {
		return this.selectedInstitution?.logoFullUrl ?? '';
	}

	get fiName(): string {
		return this.selectedInstitution?.name ?? '';
	}
}

